import types from '../actions/types';
const initialState = {
    expandedNav: false
};

export default function stagesReducer(state = initialState, action) {
    switch (action.type) {
        case types.TOGGLE_NAVBAR:
            return {
                ...state,
                expandedNav: !state.expandedNav
            };
        case types.SHOW_NAVBAR:
            return {
                ...state,
                expandedNav: true
            };
        case types.HIDE_NAVBAR:
            return {
                ...state,
                expandedNav: false
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/js/reducers/app.js